import { useMemo } from "react"

import { TailwindSandboxTwyne } from "@/modules/cms/views/post/components/builder/Content/TailwindSandbox/Twyne"

import { useCustomKeyframe } from "../../utils/tailwindConfig/hooks"

import { ANIMATION_LIST } from "./animationsPredefined"

const AnimationWrapper = ({ children }) => {
  const { value: customKeyframes } = useCustomKeyframe()

  const styles = useMemo(() => {
    const custom_list = Object.entries(customKeyframes).map(([name, keyframe]) => ({ name, keyframe }))
    const items = [...ANIMATION_LIST, ...custom_list]
    const keyframes = items.map(item => item?.keyframe && `@keyframes ${item?.name} { ${item?.keyframe} }`).filter(Boolean).join('\n')
    return `<style> ${keyframes} </style>`
  }, [customKeyframes])

  return <TailwindSandboxTwyne styles={styles}>
    {children}
  </TailwindSandboxTwyne>
}

export default AnimationWrapper
